<template>
  <el-dialog
    title="Objective Links"
    :fullscreen="true"
    :visible.sync="dialogVisible"
  >
    <el-table
      :height="windowHeight - 200"
      :data="links"
      :default-sort="{prop:'level.o_id', order: 'descending'}"
      @row-dblclick="editLink"
    >
      <el-table-column label="Class" sortable min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.level != null">{{ scope.row.level.name }}</span>
          <el-select
            v-else
            v-model="scope.row.level"
            size="small"
            value-key="o_id"
            placeholder="Select Class"
          >
            <el-option v-for="term in cLevels" :key="term.o_id" :label="term.name" :value="term" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column min-width="150" label="Objectives">
        <template slot-scope="scope">
          <el-select
            v-if="scope.row.level != null"
            v-model="scope.row.objectives"
            size="small"
            :disabled="!scope.row.editing"
            multiple
            collapse-tags
            value-key="o_id"
            placeholder="Objectives"
          >
            <el-option
              v-for="objective in cObjectives(scope.row.level.o_id)"
              :key="objective.o_id"
              :label="objective.obj_num"
              :value="objective"
            />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" label="Operations" width="120">
        <template slot-scope="scope">
          <el-button-group>
            <el-button
              v-if="scope.row.editing"
              type="primary"
              size="small"
              icon="el-icon-check"
              @click="saveLink(scope.row)"
            />
            <el-button
              v-if="scope.row.editing"
              type="info"
              size="small"
              icon="el-icon-close"
              @click="cancelEditLink(scope.row)"
            />
            <el-button
              v-if="!scope.row.editing"
              type="primary"
              size="small"
              icon="el-icon-edit"
              @click="editLink(scope.row)"
            />
            <el-button
              v-if="!scope.row.editing"
              icon="el-icon-delete"
              type="danger"
              size="small"
              @click="deleteLink(scope.row)"
            />
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="slide-bottom clearfix" type="flex">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="addLink" />
    </el-row>
  </el-dialog>
</template>

<script>
import {mapFields} from "vuex-map-fields";
export default {
    props: ["eventId"],
    data() {
        return {
            width: "70%",
            addId: -1,
            window: {
                width: 0,
                height: 0
            },
            searchList: [],
            links: [],
            backupData: [],
            objectives: null,
            dialogVisible: false
        };
    },
    computed: {
        ...mapFields(["levels"]),
        cLevels() {
            if (this.loading) return null;
            return this.levels.filter((level) => {
                return (
                    this.links.filter((link) => {
                        if (link.level) {
                            return link.level.o_id == level.o_id;
                        }
                    }).length == 0
                );
            });
        },
        loading() {
            return (
                this.links == null || this.objectives == null || this.levels == null
            );
        }
    },
    mounted() {
        if (this.levels == null) this.$store.dispatch("pullLevels");
        this.getObjectiveLinks();
        this.getObjectives();
    },
    methods: {
        getObjectiveLinks() {
            this.axios
                .get("/api/v1/objectives/links/byevent/" + this.eventId)
                .then((response) => {
                    this.links = response.data;
                })
                .catch((err) => {
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors.title,
                        type: "error"
                    });
                });
        },
        getObjectives() {
            this.axios
                .get("/api/v1/objectives")
                .then((response) => {
                    this.objectives = response.data;
                })
                .catch((err) => {
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors.title,
                        type: "error"
                    });
                });
        },
        cObjectives(levelId) {
            return this.objectives.filter((obv) => {
                return (
                    obv.level.filter((level) => {
                        return levelId == level.o_id;
                    }).length != 0
                );
            });
        },
        remoteMethod(query) {
            if (query !== "") {
                this.usersLoading = true;
                setTimeout(() => {
                    this.usersLoading = false;
                    this.searchList = this.users.filter((item) => {
                        var c = item.firstName + " " + item.lastName;
                        return c.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.searchList = [];
            }
        },
        cClassName(id) {
            var temp = this.users.find((user) => user.o_id == id);
            return temp.level.name;
        },
        addLink() {
            var nob = {
                event: this.eventId,
                level: null,
                objectives: [],
                editing: true,
                del_visible: false,
                loading: true,
                o_id: this.addId
            };
            this.addId--;
            this.links.push(nob);
        },
        editLink(val) {
            this.backupData[val.o_id] = JSON.parse(JSON.stringify(val));
            val.editing = true;
        },
        cancelEditLink(row) {
            if (row.o_id <= -1) {
                var temp = this.links.find((objv) => objv.o_id == row.o_id);
                var index = this.links.indexOf(temp);
                this.links.splice(index, 1);
            } else {
                row.editing = false;
                this.restoreLink(row.o_id);
            }
        },
        restoreLink(id) {
            var temp = this.links.find((objv) => objv.o_id == id);
            var orig = this.backupData[id];
            Reflect.deleteProperty(this.backupData, "id");

            temp.level = orig.level;
            temp.objectives = orig.objectives;
        },
        deleteLink(row) {
            row.del_visible = false;
            this.axios
                .delete("/api/v1/objectives/links/" + row.o_id, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: "Objective link deleted successfuly",
                        type: "success"
                    });
                    var temp = this.links.find((objv) => objv.o_id == row.o_id);
                    var index = this.links.indexOf(temp);
                    this.links.splice(index, 1);
                })
                .catch((err) => {
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors.title,
                        type: "error"
                    });
                });
        },
        saveLink(row) {
            row.editing = false;
            var route = "";
            var objectives = row.objectives.map((a) => a.o_id);
            if (row.o_id > -1) {
                route = "/api/v1/objectives/links/" + row.o_id;
                this.axios
                    .put(
                        route,
                        JSON.stringify({
                            event: this.eventId,
                            level_id: row.level.o_id,
                            objectives: objectives
                        }),
                        {
                            headers: {"Content-Type": "application/json"},
                            credentials: "same-origin"
                        }
                    )
                    .then(() => {
                        this.$message({
                            showClose: true,
                            message: "Objective link updated successfuly.",
                            type: "success"
                        });
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message({
                            showClose: true,
                            message: err.response.data.errors.title,
                            type: "error"
                        });
                        this.restoreLink(row.o_id);
                    });
            } else {
                route = "/api/v1/objectives/links";
                this.axios
                    .post(
                        route,
                        JSON.stringify({
                            event: this.eventId,
                            level_id: row.level.o_id,
                            objectives: objectives
                        }),
                        {
                            headers: {"Content-Type": "application/json"},
                            credentials: "same-origin"
                        }
                    )
                    .then((response) => {
                        row.o_id = response.data.o_id;
                        this.$message({
                            showClose: true,
                            message: "Objective linked successfuly",
                            type: "success"
                        });
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message({
                            showClose: true,
                            message: err.response.data.errors.title,
                            type: "error"
                        });
                        var temp = this.links.find((objv) => objv.o_id == row.o_id);
                        var index = this.links.indexOf(temp);
                        this.links.splice(index, 1);
                    });
            }
        },
        save(value) {
            this.$emit("save", value);
            this.close();
        },
        close() {
            this.dialogVisible = false;
            this.$emit("close");
        },
        open() {
            this.dialogVisible = true;
        }
    }
};
</script>
